// extracted by mini-css-extract-plugin
module.exports = {"accordionDeal":"e_c4","buttonHolder":"e_d4","button":"e_e4"};